import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { UserNetworkType } from 'user/model/user-network.type';

import { ApiPageableOutput } from '../../../../common/model/api-pageable.output';
import { ApiQuery } from '../../../../common/model/api.query';
import { ContactOutput } from '../model/contact.output';

export interface FetchProviderContactsInput {
	readonly networkType: UserNetworkType;
	readonly accessToken: string;
	readonly pageToken: string;
	readonly pageSize: number;
}

export interface FetchProviderContactsParams {
	input: FetchProviderContactsInput;
}

@Injectable({ providedIn: 'root' })
export class FetchProviderContactsApiQuery extends ApiQuery<
	ApiPageableOutput<ContactOutput>,
	FetchProviderContactsParams
> {
	client = 'iam';
	document = gql`
		query FetchProviderContacts($input: FetchProviderContactsInput!) {
			fetchProviderContacts(input: $input) {
				elements {
					...Contact
				}
				nextPageToken
				totalElements
			}
		}
		${contact}
	`;
	method = 'fetchProviderContacts';
}
